import { useContext } from 'react';
import { AmContext } from './AmContext';

export const RestrictedRender = ({ children }) => {
	const { restrictedRender } = useContext(AmContext);
	return restrictedRender ? children : null;
};
